export default "__VITE_ASSET__Dtfpz6yW__"